import { useEffect } from 'react'
import './codeCopy.styles.scss'

const CodeCopy = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = "/assets/js/copyLogic.min.js";
        script.async = true;

        document.body.appendChild(script);
 
        return () => {
            document.body.removeChild(script)
        }
    }, []) 
 
    return null
}

export default CodeCopy